var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hot-rank-wrapper"},[_c('Table',_vm._b({attrs:{"height":"100%"}},'Table',_vm.table,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }